import AddNodeEdge from "./edges/AddNodeEdge"
import {
  ACTION,
  CONDITION,
  HANDLE_OTHERWISE,
  HANDLE_OUTPUT,
  HANDLE_THEN,
  TRIGGER
} from "../nodeKind"

export const NODE_W = 220
export const NODE_H = 80

/** fitView padding. Bottom is generous (~120px in CSS pixels) so the
 *  terminal "+ Add" buttons that hang ~5.4rem below each node — and the
 *  THEN / OTHERWISE branch labels above them — stay inside the viewport
 *  after auto-fit. The other sides keep the original 25% slack so the
 *  workflow has air on the sides. */
export const FIT_VIEW_PADDING = {
  top: 0.15,
  right: 0.15,
  bottom: "120px",
  left: 0.15
} as const

export const DROP_THRESHOLD = 50

export const LAYOUT_BRANCH_OFFSET = 140
export const LAYOUT_Y_STEP = 180
/** Horizontal gap between sibling subtrees on the same condition branch
 *  handle (HANDLE_THEN or HANDLE_OTHERWISE). */
export const SIBLING_GAP = 60
/** Vertical step from a condition node down to its branch children. Larger
 *  than the generic LAYOUT_Y_STEP so the THEN/OTHERWISE pill labels and
 *  per-edge "+" buttons have room to render without crowding the cards. */
export const CONDITION_Y_STEP = 260
/** Horizontal gap between the `then` subtree and the `otherwise` subtree
 *  under a condition node. Picked so a condition with one child per branch
 *  reproduces the legacy 2 × LAYOUT_BRANCH_OFFSET spread. */
export const BRANCH_GAP = LAYOUT_BRANCH_OFFSET * 2 - NODE_W

/** Vertical step from a BRANCH node down to its case/otherwise subtrees.
 *  Same as CONDITION_Y_STEP so labels and per-edge "+" buttons get room. */
export const BRANCH_Y_STEP = CONDITION_Y_STEP
/** Per-case horizontal slot width on a BRANCH card. The card grows linearly
 *  with the number of cases so the pill labels and source handles never
 *  overlap, regardless of how many outcomes the user adds. */
export const BRANCH_CASE_SLOT_W = 110

export const HANDLE_X_PCT: Record<string, Record<string, number>> = {
  [TRIGGER]: { [HANDLE_OUTPUT]: 0.5 },
  [ACTION]: { [HANDLE_OUTPUT]: 0.5 },
  [CONDITION]: { [HANDLE_THEN]: 0.25, [HANDLE_OTHERWISE]: 0.75 }
}

export const TERMINAL_Y_OFFSET = NODE_H + 54

export const edgeTypes = {
  addNode: AddNodeEdge
}

export type TerminalTarget = { nodeId: string; handleId: string }
